import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
import 'moment/locale/zh-tw';
import { detectBrowserLanguage, supportedLngs } from './common/function/detectBrowserLanguage';

// eslint-disable-next-line import/no-named-as-default-member
i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		fallbackLng: 'en', // 如果偵測到的語言不在支援列表中，使用英文
		debug: false,
		// 支援的語言列表（包含地區代碼，用於區分繁簡中文）
		supportedLngs: supportedLngs,
		// 語言偵測配置（不使用 localStorage）
		detection: {
			// 偵測順序：navigator -> htmlTag -> path -> subdomain（不包含 localStorage）
			order: ['navigator', 'htmlTag', 'path', 'subdomain'],
			// 不快取語言到 localStorage
			caches: [],
		},
		// 不使用 load: 'languageOnly'，保留完整的地區代碼以區分繁簡中文
		// 後端配置
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json',
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		react: {
			useSuspense: false,
		},
		// 不設置固定的 lng，讓系統自動偵測
	})
	.then(() => {
		// 初始化後，使用自定義的語言偵測邏輯
		const detectedLng = detectBrowserLanguage();

		// 如果偵測到的語言與當前語言不同，則切換
		if (detectedLng !== i18n.language) {
			console.log(`[i18n] Switching language from ${i18n.language} to ${detectedLng}`);
			i18n.changeLanguage(detectedLng);
		}
	});

export default i18n;
